import ChangeCourseActionTypes from './changeCourse.types';

const initialCourseState = {
  courseDetails: {}
}

export const selectCourse = (state = initialCourseState, action = {}) => {
    switch (action.type) {
        case ChangeCourseActionTypes.FETCH_COURSES.SUCCESS:
            return Object.assign({}, state, { courseDetails: action.payload })
        default:
            return state;
    }
}